import React from 'react';
import { Layout } from "antd";
const { Footer } = Layout;

const Bottom = () => {
    return(
        <Footer style={{ textAlign: "center" }}>
           © Copyright 2020 IT60-08 ระบบตรวจจับใบหน้าเพื่อบันทึกประวัติการเข้าเรียนของนักศึกษา
        </Footer>

    )
}

export default Bottom;